import { createReducer, Action, on } from '@ngrx/store';
import * as Actions from './route-redirect.actions';
import {
  initialState,
  State,
} from '@app/core/services/router/store/route-redirect.state';

const routeRedirectReducer = createReducer(
  initialState,
  on(Actions.saveCallingRoute, (state, { url, queryParams }) => ({
    ...state,
    url,
    queryParams,
  })),
  on(Actions.clearCallingRoute, (state) => ({
    ...state,
    url: null,
    queryParams: null,
  })),
);

export function reducer(state: State | undefined, action: Action) {
  return routeRedirectReducer(state, action);
}
